import React from "react"
import { ModalConfirm } from "src/shared/components/layout"
import Icon from "src/shared/icons"

const ModalLovePointsError = ({
    isOpen,
    setIsOpen,
    titleAuthorization = "Saldo insuficiente",
    description,
    onCloseDialog,
    showPartialPaymentButton,
    onPartialPaymentClick,
}: {
    isOpen: boolean
    setIsOpen: (isOpen: boolean) => void
    titleAuthorization?: string
    description: string | undefined
    onCloseDialog: (params: { confirmed: boolean }) => void
    showPartialPaymentButton?: boolean
    onPartialPaymentClick?: () => void
}) => {

    const isZeroBalance = description?.includes("0 puntos disponibles")
    // Mostrar el botón de pago parcial solo si showPartialPaymentButton es true y NO es saldo cero
    const showPartialPayment = showPartialPaymentButton && !isZeroBalance

    return (
        <ModalConfirm
            isOpen={isOpen}
            title={titleAuthorization}
            description={
                description ? (
                    <div
                        dangerouslySetInnerHTML={{
                            __html: `<style>.description-content strong { color: var(--placeholder); font-weight: 600; }</style><div class="description-content">${description}</div>`,
                        }}
                        style={{ color: "var(--placeholder)" }}
                    />
                ) : (
                    ""
                )
            }
            icon={<Icon name="Warning" color="var(--pink-ocupado)" />}
            iconTheme="danger"
            confirmLabel="Aceptar"
            confirmButtonStyle={{ width: showPartialPayment ? "45%" : "90%" }}
            cancelButtonStyle={{ display: showPartialPayment ? "border" : "none" }}
            cancelButtonText={showPartialPayment ? "Realizar pago mixto" : undefined}
            onCloseDialog={onCloseDialog}
            onSecondaryButtonClick={showPartialPayment ? onPartialPaymentClick : undefined}
        />
    )
}

export default ModalLovePointsError
